
type UtmParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

type MhUtmParamsCookie = {
  datetime?: string;
  uri?: string;
  utm_params?: UtmParams;
};

// メモ: js の場合 Nifty.Utils.Cookie も利用可能
export const CookieUtil = {
  /**
   * Cookieから値を取得する
   * 
   * @param name Cookieのキー
   * @returns Cookieの値
   */
  getCookie(name: string): string | null {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const [key, ...valueParts] = cookie.trim().split("=");
      if (key === name) {
        return decodeURIComponent(valueParts.join("="));
      }
    }
    return null;
  },
  /**
   * mh_utm_paramsクッキーからUTMパラメータ、datetime、uriを取得
   * 
   * @returns MhUtmParamsCookie (datetime, uri, utm_params を含む)
   */
  getMhUtmParamsCookieValue(): MhUtmParamsCookie | null {
    const cookieValue = this.getCookie("mh_utm_params");
    if (!cookieValue) return null;

    try {
      const mhUtmParamsCookie = JSON.parse(cookieValue);
      const result: MhUtmParamsCookie = {
        datetime: mhUtmParamsCookie.datetime,
        uri: mhUtmParamsCookie.uri,
        utm_params: {
          utm_source: mhUtmParamsCookie.utm_params?.utm_source,
          utm_medium: mhUtmParamsCookie.utm_params?.utm_medium,
          utm_campaign: mhUtmParamsCookie.utm_params?.utm_campaign,
          utm_term: mhUtmParamsCookie.utm_params?.utm_term,
          utm_content: mhUtmParamsCookie.utm_params?.utm_content,
        }
      }
      return result;

    } catch (e) {
      console.log(e.message)
      return null
    }
  }
}
